import React from 'react';

function LeadingItServicesSection({ setView }) {
  const handleHomeClick = (e) => {
    e.preventDefault();
    if (setView) {
      if (window.location.pathname !== '/') {
        window.history.pushState({}, '', '/');
      }
      setView('home');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      window.location.href = '/';
    }
  };

  const handleDiscussClick = (e) => {
    e.preventDefault();
    const formEl = document.getElementById('it-services-hero-form') || document.querySelector('.contact-section');
    if (formEl) {
      formEl.scrollIntoView({ behavior: 'smooth' });
    } else {
      window.location.href = '/contact/';
    }
  };

  return (
    <section className="leading-it-section">
      <div className="container leading-it-container">
        {/* Left Column: Content */}
        <div className="leading-it-left">
          <h2 className="leading-it-title">
            Leading IT Services Company
          </h2>

          <p className="leading-it-desc">
            In today’s fast digital world, navigating the landscape of IT services and technology can feel overwhelming, especially for businesses that focus on growth rather than gadgets. At <a href="/" onClick={handleHomeClick} className="leading-it-red-text">Experts Communication</a>, we understand that not every company has an in-house IT department or the time to troubleshoot tech issues. Our IT company offers customized IT services and IT solutions designed to simplify the complex, support your operations, and position you for long-term success. Whether you’re just stepping into the tech space or looking to refine your current systems, our IT consultancy services are here to help you through practical, scalable solutions that actually work for your business.
          </p>

          <button className="btn-leading-it-discuss" onClick={handleDiscussClick}>
            Let's Discuss Your Needs
          </button>
        </div>

        {/* Right Column: Image */}
        <div className="leading-it-right">
          <div className="leading-it-img-wrapper">
            <img 
              src="/assets/images/it-service/it-img1.jpg" 
              alt="Leading IT Services Company - Experts Communication" 
              className="leading-it-img"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default LeadingItServicesSection;
